import * as moment from 'moment';
import { TipoDocumento } from './tipoDocumento';

export class Choferes {
	id: number;
	tipoDocumento: TipoDocumento;
	numeroDocumento: string;
	apellido: string;
	nombre: string;
	vtoLicencia: any;
	sexo: string;
	valido: boolean;
	new: boolean;
	idChofer: number;
	motivoCancelacion: string;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.tipoDocumento = new TipoDocumento(data.tipoDocumento);
			this.numeroDocumento = data.numeroDocumento;
			this.apellido = data.apellido;
			this.nombre = data.nombre;
			this.vtoLicencia = data.vtoLicencia
				? new Date(
						moment(data.vtoLicencia)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.sexo = data.sexo;
			this.valido = false;
			this.new = data.new ? data.new : false;
			this.idChofer = data.idChofer;
			this.motivoCancelacion = data.motivoCancelacion;
		}
	}
}
